import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import RemoteAccessPage from './RemoteAccess'
import ContentBlock from 'components/ContentBlock'

export const RemoteAccess = props => {
	const [pageKey, setPageKey] = useState(true)
	const [t] = useTranslation()

	const resetPage = () => {
		setPageKey(prev => !prev)
	}
	const appManagerMajorVersion = parseInt(props.data.device?.appManagerVersion?.split('.')[0], 10)

	const isAppManagerVersionCompatible = appManagerMajorVersion && appManagerMajorVersion > 0
	const isDeviceOnline = props.data.device?.deviceStatus && props.data.device?.deviceStatus !== 'offline'

	if(!isAppManagerVersionCompatible) {
		return <ContentBlock>{t('options_section.strings.update_app_manager')}</ContentBlock>
	}

	return <RemoteAccessPage key={pageKey} resetPage={resetPage} appManagerVersion={props.data.device?.appManagerVersion} isDeviceOnline={isDeviceOnline} {...props}/>
}

